import dayjs from "dayjs";
import * as Xlsx from "xlsx";
import { sanitizeExcelCell } from "@/shared/utils/excel";
import { getSales, type SalesListParams } from "../services/sales.backend";
import type { Sale } from "../types/sales.types";

const EXPORT_PAGE_SIZE = 100;

function currentDebt(sale: Sale): number {
	return sale.schedule
		.filter((item) => item.status === "delayed")
		.reduce((sum, item) => sum + (item.plannedAmount - item.paidAmount), 0);
}

async function fetchAllSales(params: Omit<SalesListParams, "page" | "limit">): Promise<Sale[]> {
	const sales: Sale[] = [];
	let page = 1;

	while (true) {
		const response = await getSales({ ...params, page, limit: EXPORT_PAGE_SIZE });
		sales.push(...response.items);
		if (sales.length >= (response.meta?.total ?? sales.length) || response.items.length === 0) {
			break;
		}
		page += 1;
	}

	return sales;
}

export async function exportSalesToExcel(
	params: Omit<SalesListParams, "page" | "limit">
): Promise<number> {
	const sales = await fetchAllSales(params);

	const rows = sales.map((sale, index) => ({
		"№": index + 1,
		"Sotuv sanasi": dayjs(sale.createdAt).format("DD.MM.YYYY"),
		"Mijoz F.I.Sh.": sanitizeExcelCell(sale.clientName),
		"Qavat / Xona": `${sale.floor}-qavat / ${sale.roomNumber}-xona`,
		"Maydon (m²)": sale.area,
		Telefon: sale.phone,
		"Oylik to'lov": sale.monthlyPayment,
		"To'langan summa": sale.paidAmount,
		"Joriy qarz (bugungi kunga)": currentDebt(sale),
		"Shartnoma summasi": sale.finalPrice,
	}));

	const worksheet = Xlsx.utils.json_to_sheet(rows);
	worksheet["!cols"] = [
		{ wch: 5 },
		{ wch: 14 },
		{ wch: 28 },
		{ wch: 20 },
		{ wch: 12 },
		{ wch: 16 },
		{ wch: 16 },
		{ wch: 16 },
		{ wch: 20 },
		{ wch: 18 },
	];

	const workbook = Xlsx.utils.book_new();
	Xlsx.utils.book_append_sheet(workbook, worksheet, "Sotuvlar");

	const fileName = `sotuvlar_${new Date().toISOString().split("T")[0]}.xlsx`;
	Xlsx.writeFile(workbook, fileName);

	return sales.length;
}
